import { AbstractDataProviderV2 } from 'components/system/data-provider';
import { A9Service } from 'components/system/angular/A9Service';
import { RsCustomerIms } from 'common/customers/services/types/RsCustomerIms';
import { RsCustomerImsInfo } from 'common/customers/services/types/RsCustomerImsInfo';
import { CustomerImsAdd } from 'common/customers/services/types/CustomerImsAdd';
import { CustomerImsUpdate } from 'common/customers/services/types/CustomerImsUpdate';

@A9Service('customerImDataProvider')
export class CustomerImDataProvider extends AbstractDataProviderV2<RsCustomerIms, RsCustomerImsInfo, CustomerImsAdd, CustomerImsUpdate> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/imses');
    }

    public patch() {
        return Promise.reject('Method `patch` is not available');
    }
}
